import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';

import { PaymentDTO, PaymentFilters } from '../../models/payment.model';

@Injectable({
  providedIn: "root"
})
export class LaravelPaymentService {
  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
      list: environment.baseUrl + "/api/payments",
      show: environment.baseUrl + "/api/payment",
      store: environment.baseUrl + "/api/payment",
      destroy: environment.baseUrl + "/api/payment",
    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: PaymentFilters,
    includes?: string[]
  ): Observable<ListResultDTO<PaymentDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
    }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<PaymentDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<PaymentDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }

  public show(id: number): Observable<PaymentDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<PaymentDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(payment: PaymentDTO): Observable<PaymentDTO> {
    if (payment.id) {
      return this.httpClient.put<PaymentDTO>(`${this.ROUTES.store}`, { payment });
    } else {
      return this.httpClient.post<PaymentDTO>(`${this.ROUTES.store}`, { payment });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
